import gql from 'graphql-tag';
import { PropertiesSearchResponseError } from './housePricesResults.query';

const HOUSE_PRICES_TRACKED_PROPERTIES_QUERY = gql`
    query housePricesTrackedProperties(
        $geoIdentifier: GeoIdentifier
        $after: ID
        $first: PositiveInt
        $fromLastSaleDate: String
        $propertyTypeCode: String
        $sortDirection: String
        $sortOrder: String
        $toLastSaleDate: String
    ) {
        propertiesSearch(
            after: $after
            first: $first
            input: {
                geoIdentifier: $geoIdentifier
                fromLastSaleDate: $fromLastSaleDate
                propertyTypeCode: $propertyTypeCode
                sortDirection: $sortDirection
                sortOrder: $sortOrder
                toLastSaleDate: $toLastSaleDate
            }
        ) {
            ... on PropertiesSearchConnection {
                edges {
                    node {
                        uprn
                        trackedProperty {
                            isTracked
                        }
                    }
                }
            }
            ...PropertiesSearchResponseError
        }
    }
    ${PropertiesSearchResponseError}
`;

export default HOUSE_PRICES_TRACKED_PROPERTIES_QUERY;
